import { DEFAULT_BORDER } from "./borderUtils";

/** @typedef {"empty" | "component" | "nestedGrid" | "blocked"} ColumnSlotKind */

/**
 * @param {{ children?: Array<{ type: string }> }} column
 */
export const getColumnSlotState = (column) => {
  const children = column?.children || [];
  const components = children.filter((child) => child.type === "component");
  const grids = children.filter((child) => child.type === "grid");

  if (grids.length > 0) {
    return {
      kind: "nestedGrid",
      hasNestedGrid: true,
      hasComponent: false,
      component: null,
      nestedGrid: grids[0],
      canAcceptComponent: false,
      canAcceptNestedGrid: grids.length === 0,
    };
  }

  if (components.length > 0) {
    return {
      kind: "component",
      hasNestedGrid: false,
      hasComponent: true,
      component: components[0],
      nestedGrid: null,
      canAcceptComponent: true,
      canAcceptNestedGrid: false,
      needsReplace: true,
    };
  }

  return {
    kind: "empty",
    hasNestedGrid: false,
    hasComponent: false,
    component: null,
    nestedGrid: null,
    canAcceptComponent: true,
    canAcceptNestedGrid: true,
    needsReplace: false,
  };
};

/**
 * Drop target highlight: ok = empty cell; invalid = occupied or nested grid.
 * @param {{ children?: Array<{ type: string }> }} column
 * @returns {"ok" | "invalid" | null}
 */
export const getColumnDropHighlight = (column, isComponentDrag) => {
  if (!isComponentDrag) {
    return null;
  }
  const state = getColumnSlotState(column);
  if (state.hasNestedGrid || state.hasComponent) {
    return "invalid";
  }
  return "ok";
};

/**
 * @param {{ children?: Array<{ type: string, id: string }> }} column
 */
export const sanitizeColumnChildren = (column) => {
  if (!column?.children?.length) {
    column.children = [];
    return column;
  }
  const grids = column.children.filter((child) => child.type === "grid");
  const components = column.children.filter((child) => child.type === "component");

  if (grids.length > 0 && components.length > 0) {
    column.children = [components[0]];
    return column;
  }
  if (components.length > 1) {
    column.children = [components[0]];
    return column;
  }
  if (grids.length > 1) {
    column.children = [grids[0]];
    return column;
  }
  column.children = [...grids, ...components];
  return column;
};

export const defaultComponentBorder = () => ({
  ...DEFAULT_BORDER,
  top: { ...DEFAULT_BORDER.top },
  right: { ...DEFAULT_BORDER.right },
  bottom: { ...DEFAULT_BORDER.bottom },
  left: { ...DEFAULT_BORDER.left },
});
 